import { DEFAULT_LOCALE, LOCALE_SPEED_UNITS } from '../../constants';

export const getSpeedUnit = (locale: string | undefined) => {
  return LOCALE_SPEED_UNITS[locale ?? DEFAULT_LOCALE] ?? 'km/h';
};
